import { useRef, useState, useEffect } from 'react';

import { Filter } from 'vindi-ds-components';

import api from '@services/api';

import listData from '../../utils/list_data';

import ransackFormat from '../../utils/ransack_form';

import { quick as schemaQuick, advanced as schemaAdvanced } from './schema.json';

async function listBills(params) {
  const request = await api.get('/admin/reports/bills', ransackFormat(params));

  const bills = listData(request?.data.bills, params);

  return {
    bills,
    totalCount: request?.data.bills.length,
  };
}

const pagination = {
  enabled: true,
  perPage: 20,
  getCount: async (query) => query?.data?.totalCount,
};

function useFilterBills() {
  const [filterFields, setFilterFields] = useState(null);

  useEffect(() => {
    api.get('/admin/reports/filters_parameters_by_report', { report: 'bills_report' }).then((response) => {
      setFilterFields(response?.data?.bills_filter?.fields);
    });
  }, []);

  const listing = Filter.useBrowserListing({
    queryOptions: {
      queryKey: 'bills',
      queryFn: listBills,
    },
    filterOptions: {
      schemaQuick,
      schemaAdvanced,
      pagination,
    },
  });

  const modalDownloadRef = useRef();

  return {
    listing,
    modalDownloadRef,
    filterFields,
  };
}

export default useFilterBills;
